import { Box, Chip, Stack, Typography, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { useApiQuery } from '../query/hooks';
import { graphql } from '../gql';
import { FormattedMessage } from 'react-intl';
import { PersonaAvatarSmall } from '../persona/PersonaAvatar';

const listPersonasQuery = graphql(`
	query personasSelect_listPersona {
		listPersona {
			id
			name
			...PersonaAvatar_persona
		}
	}
`);

type PersonasSelectProps = Readonly<{
	value: readonly string[];
	onChange(newTags: readonly string[]): void;
	loading?: boolean;
	size: 'medium' | 'small';
}>;

export const PersonasCheckList: FC<PersonasSelectProps> = ({ value, onChange, loading, size }) => {
	const { data } = useApiQuery(listPersonasQuery);
	const theme = useTheme();

	const personas = data?.listPersona.map((persona) => persona) ?? [];

	const selectedPersonas = value.filter((id) => personas.some((o) => o.id === id));

	if (loading) {
		return (
			<Typography sx={{ color: theme.palette.secondary.main }}>
				<FormattedMessage id={'common.loading'} />
			</Typography>
		);
	}

	return (
		<Stack direction={'column'} gap={2}>
			{personas.length > 0 && (
				<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
					{personas.map((persona) => (
						<Chip
							key={persona.id}
							label={persona.name}
							variant={'outlined'}
							size={size}
							sx={{
								backgroundColor: theme.palette.secondary.lighter,
								borderColor: selectedPersonas.includes(persona.id) ? theme.palette.primary[400] : theme.palette.secondary[400],
								opacity: selectedPersonas.includes(persona.id) ? 1 : 0.5,
							}}
							avatar={
								<Box>
									<PersonaAvatarSmall persona={persona} />
								</Box>
							}
							onClick={() =>
								selectedPersonas.includes(persona.id)
									? onChange(selectedPersonas.filter((pId) => pId !== persona.id))
									: onChange(selectedPersonas.concat(persona.id))
							}
						/>
					))}
				</Box>
			)}
		</Stack>
	);
};
